import IntegrationsTable from '../../components/IntegrationsTable';

export default function IntegrationsSettings() {
  return <IntegrationsTable />;
}
